<template>
  <div>
    <base-card v-if="isLoading">
      <div class="tw-flex tw-justify-between">
        <div class="tw-flex tw-flex-col tw-flex-grow">
          <base-skeleton-loader class="tw-h-5 tw-w-32 tw-mb-2" />
          <base-skeleton-loader class="tw-h-4 tw-w-1/2" />
        </div>
        <base-icon>
          <more-vertical-icon class="tw-w-6 tw-h-6" />
        </base-icon>
      </div>
      <div class="tw-grid tw-grid-cols-2 tw-mt-6 tw-gap-4">
        <div class="tw-grid tw-grid-rows-2 tw-gap-4">
          <div class="tw-flex tw-flex-col">
            <base-skeleton-loader class="tw-h-3 tw-w-1/4" />
            <base-skeleton-loader class="tw-h-4 tw-w-1/2 tw-mt-2" />
          </div>
          <div class="tw-flex tw-flex-col">
            <base-skeleton-loader class="tw-h-3 tw-w-1/4" />
            <base-skeleton-loader class="tw-h-4 tw-w-1/2 tw-mt-2" />
          </div>
        </div>
        <div class="tw-grid tw-grid-rows-2 tw-gap-4">
          <div class="tw-flex tw-flex-col">
            <base-skeleton-loader class="tw-h-3 tw-w-1/4" />
            <base-skeleton-loader class="tw-h-4 tw-w-1/2 tw-mt-2" />
          </div>
          <div class="tw-flex tw-flex-col">
            <base-skeleton-loader class="tw-h-3 tw-w-1/4" />
            <base-skeleton-loader class="tw-h-4 tw-w-1/2 tw-mt-2" />
          </div>
        </div>
      </div>
    </base-card>
    <div v-else>
      <div class="tw-flex tw-mb-3 tw-justify-end">
        <div class="tw-text-sm tw-mr-2 tw-my-auto tw-text-gray-800 tw-cursor-pointer">Show deleted plans</div>
        <base-toggle v-model="showDeleted" />
      </div>
      <div v-for="plan in orderedMemberPlans" :key="plan.userBusinessPlanId">
        <BusinessMemberPlan
          :plan="plan"
          :refreshId="refreshId"
          :businessId="businessId"
          :userId="userId"
          :member-full-name="memberFullName"
          @activate="showActivation(plan)"
          @refresh="refresh"
        >
        </BusinessMemberPlan>
      </div>
    </div>
    <business-member-plan-activation ref="activationModal" :userId="userId" :businessId="businessId" @activated="loadMemberPlans" />
  </div>
</template>

<script>
import BusinessMemberPlan from "@/views/business/member/plans/components/BusinessMemberPlan.vue";
import BusinessMemberPlanActivation from "@/views/business/member/plans/components/BusinessMemberPlanActivation";
import { MoreVerticalIcon } from "@/assets/svgs";
import _ from "lodash";

export default {
  name: "BusinessMemberPlans",
  components: { BusinessMemberPlan, BusinessMemberPlanActivation, MoreVerticalIcon },
  props: {
    businessId: String,
    userId: String,
    memberFullName: String,
  },
  data() {
    return {
      memberplans: [],
      isLoading: false,
      showDeleted: false,
      refreshId: 1,
    };
  },
  computed: {
    orderedMemberPlans: function() {
      return _.sortBy(this.memberplans, [
        function(p) {
          return p.status;
        },
      ]);
    },
  },
  mounted() {
    this.loadMemberPlans();

    this.EventBus.$on("member_update", this.loadMemberPlans);
  },
  beforeDestroy() {
    this.EventBus.$off("member_update", this.loadMemberPlans);
  },
  watch: {
    userId() {
      this.loadMemberPlans();
    },
    showDeleted() {
      this.loadMemberPlans();
    },
  },
  methods: {
    refresh() {
      this.loadMemberPlans();
    },
    loadMemberPlans() {
      this.isLoading = true;
      let url = `/businesses/${this.businessId}/members/${this.userId}/memberplans?showDeleted=${this.showDeleted}`;
      this.$axios
        .get(url)
        .then((res) => {
          this.memberplans = res.data;
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: "Unable to load member plans",
            message: "We were not able to retrieve the member plan. There may have been a connection error. Please reload the page to try again.",
            err,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showActivation(plan) {
      this.$refs.activationModal.show(plan);
    },
  },
};
</script>
